import {
  newContract,
  newContractToken,
  refund,
  withdraw,
  allowance,
  approve,
} from './hexlant';
import {
  logIn,
  logInOTP,
  confirmOTP,
  requestRefreshToken,
  confirmRecaptcha,
} from './logIn';
import {
  getBalance,
  getBalanceDev,
  getTransactionStateWithTxHash,
} from './octet';

const KStadiumAPI = {
  logIn,
  logInOTP,
  confirmOTP,
  confirmRecaptcha,
  requestRefreshToken,
  getTransactionStateWithTxHash,
  withdraw,
  newContract,
  newContractToken,
  refund,
  getBalance,
  getBalanceDev,
  allowance,
  approve,
};

export default KStadiumAPI;
